// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__2thpr","icon":"loading_icon__CILWh","animal":"loading_animal__2PglA"};